import { differenceInCalendarMonths, isValid } from "date-fns";
import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const monthsUntil = (dueDate: Date | undefined | null): number => {
	if (!dueDate || !isValid(dueDate)) return 0;
	return Math.max(0, differenceInCalendarMonths(dueDate, new Date()));
};

export const monthlyContribution = (
	savingsTarget: number,
	dueDate: Date | undefined | null,
	annualRate: number = GOAL_REAL_YIELD,
): number => {
	const months = monthsUntil(dueDate);
	if (savingsTarget <= 0 || months <= 0) return 0;
	const r = annualRate / 12;
	const factor = (1 + r) ** months - 1;
	return Math.round((savingsTarget * r) / factor);
};
